import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ComicCard from '@/components/base/ComicCard';
import { getFeaturedComics, getLatestComics, getPopularComics, comics } from '@/mocks/comics';
import { categories } from '@/mocks/categories';

export default function Home() {
  const featured = getFeaturedComics();
  const latest = getLatestComics(8);
  const popular = getPopularComics(8);

  return (
    <>
      <ScrollToTop />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "虫虫漫画",
        "url": "https://chongchongmanga.com",
        "description": "虫虫漫画大全汇集全集免费漫画，好看的韩漫日漫国漫分类推荐，支持下拉式在线阅读，追更收藏尽在虫虫漫画平台，海量内容一网打尽。",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://chongchongmanga.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        },
        "inLanguage": "zh-CN"
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "虫虫漫画 - 虫虫漫画大全 | 虫虫漫画全集免费在线看",
        "description": "虫虫漫画大全汇集全集免费漫画，好看的韩漫日漫国漫分类推荐，支持下拉式在线阅读，追更收藏尽在虫虫漫画平台，海量内容一网打尽。",
        "url": "https://chongchongmanga.com",
        "isPartOf": {
          "@type": "WebSite",
          "name": "虫虫漫画",
          "url": "https://chongchongmanga.com"
        },
        "inLanguage": "zh-CN"
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://chongchongmanga.com"
          }
        ]
      }) }} />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20anime%20style%20illustration%20with%20warm%20golden%20and%20coral%20gradient%20background%2C%20abstract%20flowing%20lines%20and%20ink%20wash%20textures%2C%20Japanese%20and%20Chinese%20manga%20aesthetic%20blend%2C%20soft%20ethereal%20light%20effects%2C%20minimalist%20and%20elegant%20composition%2C%20no%20specific%20characters%2C%20atmospheric%20and%20dreamy&width=1600&height=900&seq=manga-hero-bg&orientation=landscape"
            alt="虫虫漫画 - 全集免费在线看"
            title="虫虫漫画大全 - 好看的漫画下拉式阅读"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <div className="w-full max-w-3xl">
              <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-4 leading-tight">
                虫虫漫画大全
              </h1>
              <p className="text-sm md:text-lg text-background-50/80 mb-6 max-w-xl mx-auto leading-relaxed">
                虫虫漫画全集免费在线看，汇集韩漫日漫国漫分类推荐<br className="hidden md:block" />
                支持下拉式在线阅读，追更收藏尽在虫虫漫画平台
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <Link
                  to="/category/hanman"
                  className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  开始阅读
                </Link>
                <Link
                  to="/category/guoman"
                  className="px-6 py-2.5 rounded-full bg-background-50/20 text-background-50 text-sm font-medium hover:bg-background-50/30 border border-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
                >
                  国漫专区
                </Link>
              </div>
            </div>
          </div>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
            <i className="ri-arrow-down-s-line text-background-50/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full bg-background-50 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-4">
            <div className="flex items-center justify-center gap-3 flex-wrap">
              {categories.map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 hover:bg-primary-100 text-foreground-700 hover:text-primary-600 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Section */}
        <section className="w-full px-4 md:px-6 py-14">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">虫虫漫画精选推荐，不容错过的好看的漫画</p>
            </div>
            <Link to="/category/hanman" className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap">
              查看更多 <i className="ri-arrow-right-line text-xs w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="true">
            {featured.map(comic => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        </section>

        {/* Latest Updates + Popular Grid */}
        <section className="w-full bg-background-100/70">
          <div className="w-full px-4 md:px-6 py-14">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              {/* Latest Updates */}
              <div>
                <div className="flex items-center justify-between mb-8">
                  <div>
                    <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                      最新更新
                    </h2>
                    <p className="text-sm text-foreground-500 mt-1">虫虫漫画持续更新，追更不等待</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4" data-product-shop="true">
                  {latest.map(comic => (
                    <ComicCard key={comic.id} {...comic} />
                  ))}
                </div>
              </div>

              {/* Popular Ranking */}
              <div>
                <div className="flex items-center justify-between mb-8">
                  <div>
                    <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                      人气排行
                    </h2>
                    <p className="text-sm text-foreground-500 mt-1">虫虫漫画人气最高漫画排行</p>
                  </div>
                </div>
                <div className="space-y-3">
                  {popular.slice(0, 8).map((comic, index) => (
                    <Link
                      key={comic.id}
                      to={`/comic/${comic.id}`}
                      className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer group"
                    >
                      <span className={`w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold whitespace-nowrap ${
                        index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                      }`}>
                        {index + 1}
                      </span>
                      <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0 bg-background-200">
                        <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                          {comic.title}
                        </h3>
                        <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{comic.author}</p>
                      </div>
                      <div className="text-right flex-shrink-0">
                        <p className="text-xs text-accent-500 font-semibold whitespace-nowrap">
                          <i className="ri-star-fill text-xs mr-0.5"></i>{comic.rating}
                        </p>
                        <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">
                          {(comic.views / 10000).toFixed(0)}万
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-50">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto text-center">
            {[
              { label: '收录漫画', value: '12,000+', icon: 'ri-book-open-line' },
              { label: '高清章节', value: '50万+', icon: 'ri-file-list-3-line' },
              { label: '日活用户', value: '80万+', icon: 'ri-user-smile-line' },
              { label: '累计阅读', value: '5亿+', icon: 'ri-eye-line' },
            ].map((stat, idx) => (
              <div key={idx} className="p-4">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${stat.icon} text-primary-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <p className="text-2xl font-heading text-foreground-900">{stat.value}</p>
                <p className="text-sm text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20soft%20warm%20abstract%20background%20with%20flowing%20ink%20textures%20in%20coral%20and%20cream%20tones%2C%20artistic%20Japanese%20sumi-e%20style%20blended%20with%20modern%20minimalist%20design%2C%20gentle%20gradients%2C%20no%20text%2C%20elegant%20and%20subtle%20atmosphere&width=1600&height=600&seq=manga-cta-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary-500/90" />
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
              加入虫虫漫画，开启阅读之旅
            </h2>
            <p className="text-background-50/80 text-sm md:text-base mb-6 max-w-lg mx-auto">
              虫虫漫画大全，全集免费在线看，好看的漫画随时随地下拉式阅读
            </p>
            <Link
              to="/category/hanman"
              className="inline-flex px-8 py-3 rounded-full bg-background-50 text-primary-500 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即探索
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}